export default __webpack_public_path__ + "static/media/ACPL.c646f495.png";